import { useState } from "react";
import { Gift, Check } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { currencyGainToast } from "@/lib/currencyToastGate";
import { btn } from "@/components/Page";

export default function PromoCodeRedemption() {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const redeemCode = async (e) => {
    e.preventDefault();
    
    if (!code.trim()) {
      toast.error("Please enter a promo code");
      return;
    }
    
    setBusy(true);
    try {
      const { data } = await api.post("/promo-codes/redeem", { code: code.trim() });
      
      const hasCurrencyReward = data.rewards.some((reward) => /\b(gold|follis)\b/i.test(String(reward)));
      const rewardToast = hasCurrencyReward ? currencyGainToast : toast.success;
      rewardToast(
        <div>
          <p className="font-semibold mb-1">Promo code redeemed!</p>
          <p className="text-sm">{data.rewards.join(", ")}</p>
        </div>,
        { icon: <Gift className="text-amber-400" /> }
      );
      
      setCode("");
      
      // Refresh user data to show updated gold/inventory
      window.dispatchEvent(new Event("lanista:refresh-user"));
    } catch (e) {
      toast.error(apiErr(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="border border-amber-900/30 bg-zinc-950/60 p-6">
      <div className="flex items-center gap-2 mb-3">
        <Gift size={20} className="text-amber-400" />
        <h3 className="font-cinzel text-amber-300 uppercase tracking-wide">
          Redeem Promo Code
        </h3>
      </div>
      
      <p className="text-sm text-zinc-400 mb-4">
        Have a promo code? Enter it below to claim your rewards.
      </p>
      
      <form onSubmit={redeemCode} className="flex gap-2">
        <input
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          placeholder="Enter promo code..."
          maxLength={30}
          disabled={busy}
          className="flex-1 bg-zinc-900 border border-amber-900/40 px-4 py-2.5 text-zinc-100 font-mono placeholder-zinc-600 focus:border-amber-600 outline-none disabled:opacity-50"
        />
        <button
          type="submit"
          disabled={busy || !code.trim()}
          className={btn() + " px-6 flex items-center gap-2"}
        >
          <Check size={16} /> Redeem
        </button>
      </form>
    </div>
  );
}
